jQuery(document).ready(function($) {
    const $blocks = $('.wp-block-jormi-blocks-query-card');
    const $triggers = $blocks.find('[data-hs-overlay]');
    
    $triggers.on('click', function(e) {
        e.preventDefault();
        
        const overlayId = $(this).data('hs-overlay');
        
        // Set overflow hidden on html element
        $('html').css('overflowY', 'hidden');
        
        // Listen for click on close button and overlay background to restore scroll
        const $overlay = $(overlayId);
        const $closeButton = $overlay.find('button[data-hs-overlay]');
        $closeButton.one('click', function() {
            $('html').css('overflowY', 'auto');
        });
        
        // Listen for click on overlay to restore scroll (clicks on children is not considered a close event)
        $overlay.on('click', function(e) {
            if (e.target === this) {
                $('html').css('overflowY', 'auto');
                // Remove this event listener after it's triggered
                $(this).off('click');
            }
        });
    });
    
    // Handle Escape key to close overlay and restore scroll
    $(document).on('keyup', function(e) {
        if (e.key === 'Escape') {
            $('html').css('overflowY', 'auto');
        }
    });
});